import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.0361 6.06055C17.4082 5.59416 18.0977 5.51038 18.5762 5.87305C19.0546 6.23582 19.1407 6.9076 18.7686 7.37402L10.6211 17.5869C10.2245 18.0839 9.47517 18.1407 9.00391 17.71L4.34766 13.4551C3.90575 13.051 3.88362 12.3744 4.29785 11.9434C4.71243 11.5123 5.4074 11.4904 5.84961 11.8945L9.62695 15.3457L17.0361 6.06055Z"
      fill="#0DB08C"
    />
  </svg>
);
export default SVGComponent;
